/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { motion } from "framer-motion";

// eslint-disable-next-line object-curly-newline
import { FiUserCheck, FiTrendingUp, FiUsers, FiBarChart2, FiFileText, FiClipboard, FiUser, FiInfo } from 'react-icons/fi';
import { FaUserTie } from "react-icons/fa";

// Seven Core Service Areas with details
const companyServices = [
  {
    icon: FiUserCheck,
    title: 'Pre-Screened Professional Access',
    items: [
      'Multi-layer integrity and background verification',
      'Independence criteria assessment per Companies Act, 2013',
      'Regular credential revalidation and professional reference checks',
    ],
  },
  {
    icon: FiTrendingUp,
    title: 'Cost-Effective Platform',
    items: [
      'Significantly reduced costs compared to traditional executive search',
      'AI-powered matching reducing time-to-appointment from months to weeks',
      'Transparent pricing with no hidden consultant fees',
    ],
  },
  {
    icon: FiUsers,
    title: 'Women Director Access',
    items: [
      'Dedicated pool supporting SEBI LODR diversity requirements',
      'Special focus on top 1000 listed entity requirements for independent women directors',
      'Mentorship and development programs for emerging women leaders',
    ],
  },
  {
    icon: FiBarChart2,
    title: 'Compensation Benchmarking',
    items: [
      'Give-to-get model providing comprehensive market intelligence',
      'Industry and company size specific benchmarking data',
      'Compliance with regulatory limits including recent amendments to Companies Act, 2013',
    ],
  },
  {
    icon: FiFileText,
    title: 'Documentation Support',
    items: [
      'Annual certification templates and compliance calendar systems',
      'Board evaluation frameworks meeting SEBI and Companies Act requirements',
      'Letter of appointment templates with all regulatory provisions',
    ],
  },
  {
    icon: FiClipboard,
    title: 'IPO/DRHP Support',
    items: [
      'Board composition analysis for SEBI LODR compliance',
      'Director profile preparation and validation services',
      'Practicing company secretary certificate assistance',
    ],
  },
  {
    icon: FiBarChart2,
    title: 'Board Assessments',
    items: [
      'Structured evaluation frameworks for boards, committees, and individual directors',
      'Performance metrics aligned with regulatory requirements',
      'Benchmark comparisons with industry peers and action plan development',
    ],
  },
];

// Accordion component for each service
function AccordionItem({ icon: Icon, title, items }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-white rounded-xl shadow-md mb-4 border-l-4 border-theme-blue hover:shadow-lg transition-all duration-300">
      <div
        className="flex justify-between items-center cursor-pointer p-5"
        onClick={() => setOpen(!open)}
      >
        <div className="flex items-center">
          <Icon size={24} className="text-theme-blue mr-3" />
          <h4 className="text-lg font-semibold text-theme-blue">{title}</h4>
        </div>
        <span className={`text-theme-blue font-bold transition-transform duration-300 ${open ? 'rotate-45' : ''}`}>+</span>
      </div>
      {/* Smooth Collapse */}
      <div
        className="overflow-hidden transition-all duration-500 ease-in-out"
        style={{ maxHeight: open ? `${items.length * 2.5}rem` : '0' }}
      >
        <ul className="list-disc list-inside mt-2 ml-5 text-gray-600 text-sm space-y-2 pb-4 leading-relaxed">
          {items.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function CompanyCharterContent() {
  return (
    <>

      {/* ✅ FULL-WIDTH CORE SERVICE SECTION */}
      <Fade bottom triggerOnce delay={200}>
        <section className="relative w-full min-h-[700px] flex items-center">
          {/* Full-width purple slant background */}
          <div
            className="absolute inset-0 -z-10 bg-gradient-to-b from-theme-purple to-white"
            style={{
              clipPath: 'polygon(0 0, 100% 10%, 100% 100%, 0 100%)',
            }}
          />

          <div className="container mx-auto px-6 pt-20 pb-0">
            <h2 className="text-4xl font-extrabold text-white mb-12 text-center container mx-auto pb-2 px-6">
            Comprehensive platform overview
          </h2>
            <h2 className="text-3xl font-bold text-white text-center mb-16">
              Core Areas
            </h2>
            {/* Flow container */}
            <div className="flex flex-wrap justify-center items-center gap-12 relative">
              {[
                { title: "Pre-Screened Professional Access", icon: FiUserCheck },
                { title: "Cost-Effective Platform", icon: FiTrendingUp },
                { title: "Women Director Access", icon: FiUsers },
                { title: "Documentation Support", icon: FiFileText },
                { title: "Board Assessments", icon: FiBarChart2 },
              ].map((service, idx, arr) => {
                const Icon = service.icon;
                return (
                  <div key={idx} className="relative flex flex-col items-center">
                    <motion.div
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ delay: idx * 0.2 }}
                      className="w-40 h-40 rounded-full bg-white border-2 border-theme-blue shadow-lg flex flex-col items-center justify-center text-center px-4"
                    >
                      <div className="w-14 h-14 rounded-full bg-theme-blue flex items-center justify-center text-white mb-3">
                        <Icon size={28} />
                      </div>
                      <h5 className="text-sm font-semibold text-gray-800">
                        {service.title}
                      </h5>
                    </motion.div>

                    {/* Arrow except last circle */}
                    {idx < arr.length - 1 && (
                      <div className="hidden md:flex items-center absolute right-[-4.5rem] top-1/2 -translate-y-1/2">
                        <div className="w-12 h-[2px] bg-white/70" />
                        <div className="w-0 h-0 border-t-[6px] border-b-[6px] border-l-[10px] border-t-transparent border-b-transparent border-l-white ml-1" />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </Fade>

      {/* Charter Commitment Section (back to white background) */}
      <Fade bottom triggerOnce delay={400}>
        <section className="max-w-6xl mx-auto px-6 pt-0 pb-16 bg-gray-50">
          <h2 className="text-3xl font-bold text-theme-purple text-center">
            Our Commitment to Companies
          </h2>
          <p className="text-gray-700 text-base leading-relaxed mb-12 py-8 justify-evenly">
            As a platform enabling access to leading independent directors, 
            we commit to helping companies strengthen their boards through 
            transparency, efficiency, and integrity. Companies participating 
            in the platform can expect:
          </p>
          <div className="grid gap-8 md:grid-cols-2">
            {/* Access to Talent Pool */}
            <div className="bg-white shadow rounded-lg p-6 flex flex-col items-start">
              <div className="mb-4 bg-theme-purple rounded-sm"><FiUser size={45} className="text-white" /></div>
              <h4 className="text-xl font-semibold text-theme-purple mb-3">Access to Talent Pool</h4>
              <ul className="text-gray-700 space-y-2">
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">A wide network of senior professionals who are pre-screened for integrity, 
                  credentials, and governance track record.</li><br />
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">A diverse pool with special focus on facilitating women directors, supporting 
                  gender-balance objectives.</li>
              </ul>
            </div>
            {/* Cost-Effective Recruitment */}
            <div className="bg-white shadow rounded-lg p-6 flex flex-col items-start">
              <div className="mb-4 bg-theme-purple rounded-sm"><FiBarChart2 size={45} className="text-white" /></div>
              <h4 className="text-xl font-semibold text-theme-purple mb-3">Cost-Effective Platform</h4>
              <ul className="text-gray-700 space-y-2">
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">Streamlined and transparent processes to reduce hiring costs relative to 
                  traditional search methods.</li><br />
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">“Give-to-Get” benchmarking: fair understanding of compensation structures
                  and norms across sectors.</li>
              </ul>
            </div>
          </div>

          {/* Second Row */}
          <div className="grid gap-8 md:grid-cols-2 mt-8">
            {/* Board Governance Support */}
            <div className="bg-white shadow rounded-lg p-6 flex flex-col items-start">
              <div className="mb-4 bg-theme-purple rounded-sm"><FiFileText size={45} className="text-white" /></div>
              <h4 className="text-xl font-semibold text-theme-purple mb-3">Compliance & Good Practices</h4>
              <ul className="text-gray-700 space-y-2 justify-evenly">
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">Guidance on evolving governance regulations and frameworks.</li><br />
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">Periodic updates on compensation, training, and boardroom practices.</li>
              </ul>
            </div>

            {/* Board Governance Support Additional Block */}
            <div className="bg-white shadow rounded-lg p-6">
              <div className="inline-flex items-center mb-3 bg-theme-purple rounded-sm"><FiClipboard size={45} className="text-white" /></div>
              <h4 className="text-xl font-semibold text-theme-purple mb-3">Board Governance Support</h4><br />
              <ul className="text-gray-700 space-y-2 list-none">
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">
                  Assistance in preparing director-related documentation, including annual 
                  certifications and filings.
                </li>
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">
                  Support for IPO-related requirements such as disclosures in the Draft Red
                  Herring Prospectus (DRHP).
                </li>
                <li className="relative pl-5 before:absolute before:left-0 before:top-2 before:h-2 before:w-2 before:rounded-full before:bg-theme-purple">
                  Facilitation of annual board and committee effectiveness assessments in 
                  line with governance best practices.
                </li>
              </ul>
            </div>
          </div>
        </section>
      </Fade>

    </>
  );
}
